<div class="journey-switch" role="group" aria-label="Visão do deal">
  <button
    type="button"
    class="journey-switch__option"
    [class.journey-switch__option--active]="!banksActive()"
    [attr.aria-pressed]="!banksActive()"
    (click)="select('deal')">
    <i class="pi pi-sitemap" aria-hidden="true"></i>
    {{ dealLabel() }}
  </button>

  <!-- Botão desabilitado não recebe o hover: o aviso do cadeado fica no wrapper. -->
  <span
    class="journey-switch__wrap"
    [pTooltip]="locked() ? lockedTooltip() : ''"
    tooltipPosition="bottom">
    <button
      type="button"
      class="journey-switch__option"
      [class.journey-switch__option--active]="banksActive()"
      [class.journey-switch__option--locked]="locked()"
      [disabled]="banksDisabled()"
      [attr.aria-pressed]="banksActive()"
      [attr.aria-label]="locked() ? 'Jornada nos bancos. ' + lockedTooltip() : null"
      (click)="select('banks')">
      <i [class]="locked() ? 'pi pi-lock' : 'pi pi-building-columns'" aria-hidden="true"></i>
      Jornada nos bancos
      @if (store.unlocked()) {
        <span class="journey-switch__count">{{ store.allCards().length }}</span>
      }
    </button>
  </span>
</div>
